import { render, staticRenderFns } from "./ProjectComponents.vue?vue&type=template&id=b5ba5f4a&"
import script from "./ProjectComponents.vue?vue&type=script&lang=js&"
export * from "./ProjectComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5ba5f4a')) {
      api.createRecord('b5ba5f4a', component.options)
    } else {
      api.reload('b5ba5f4a', component.options)
    }
    module.hot.accept("./ProjectComponents.vue?vue&type=template&id=b5ba5f4a&", function () {
      api.rerender('b5ba5f4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/portfolio/projects/ProjectComponents.vue"
export default component.exports